import React from 'react';

interface Props {
    currentActiveNav: number;
    activeNavValue: number;
    children: JSX.Element | JSX.Element[];
}

const TabSeccion = ({ currentActiveNav, activeNavValue, children }: Props) => {
    return (
        <div
            className={`tab-pane ${currentActiveNav == activeNavValue && 'active'}`}
        >
            {children}
        </div>
    );
};

export default TabSeccion;
